export default __webpack_public_path__ + "static/scrapingbee-0de66497717e76d07146fdffcb42ad24.png";